import getSlugFromUrl from '@/utils/getSlugFromUrl';
import { YA_METRIC_ID } from '~/constants';

export default defineNuxtPlugin(() => {
  const { $logger } = useNuxtApp();

  const log = $logger.withScope('🚩🔗 clickOutside');

  function linkClickHandler(event: MouseEvent) {
    const currentSlug = getSlugFromUrl(window.location.href);
    const link = (event.target as HTMLElement)?.closest('a');

    if (!link) return;

    log('link click', link?.href);
    window.ym?.(YA_METRIC_ID, 'params', {
      // * аналитик попросил сделать такую структуру
      outer_transition: { [currentSlug]: [link?.href] },
    });
  }

  document.addEventListener('click', linkClickHandler, { passive: true });
});
